export const catalogUrls = [
  '/galleries',
  '/artists',
  '/artworks'
]

export default {
  SIGN_UP: '/signup',
  RESET_PASSWORD: '/resetpassword'
}
